<template>
  <div :class="['app-wrapper', (hide || NODE_ENV === 'erp-prod')?'w100':'']" :style="`${hide? 'min-width: unset' : ''}`">
    <nav-top v-if="!hide && !($route.query.token || hasToken)"></nav-top>
    <erpnavtop v-if="$route.query.token || hasToken"></erpnavtop>
    <div class="con" :class="{'hide':hide||this.$route.query.hide}">
      <!-- <sidebar class="sidebar-container" v-show="!hide"></sidebar> -->
      <div class="main-container" :class="{'hide':hide||this.$route.query.hide}">
        <menubar v-show="!hide"></menubar>
        <three-level-view></three-level-view>
      </div>
    </div>

    <!-- <el-popover placement="left" width="380" trigger="click">
      <ul class="service-list">
        <a href="https://www.71360.com/index/intelligence.html" target="__blank">
          <li>
            <span class="consul"></span>
            <div>
              <h5>智能顾问</h5>
              <p>智能诊断，秒级解答</p>
            </div>
          </li>
        </a>
        <li @click="clickSuggestion">
          <span  class="suggest"></span>
          <div>
            <h5>聆听·建议反馈</h5>
            <p>71360不是完美的，我们渴望您的建议</p>
          </div>
        </li>
      </ul>
      <div class="service" slot="reference" v-if="!hide">
        <p>
          <img src="~@/assets/gbIcon/customer.png" alt="">
          <span>咨询建议</span>
        </p>
        <div>
        </div>
      </div>
    </el-popover> -->
    
    <callFixed ref="callFixed" />
    <!--企业上报全局轮询-->
    <companyReport :showBtn="false" style="margin: 0;" />

    <!-- 订阅消息推送轮询 -->
      <subscribe-info-push v-if="!subscribeMsg" ref="subscribeInfoPush"></subscribe-info-push>
    <!-- 批量解锁提示 -->
     <batch-unlock-tip ref="batchUnlockTip"></batch-unlock-tip>
  </div>

</template>

<script>
import { getCookie } from '@/base/cookie'
import callFixed from '@/components/callFixed'
import Sidebar from './components/Sidebar/index'
import { NavTop, ThreeLevelView, menubar } from './components'
import erpnavtop from './components/erpnavtop'
import companyReport from '../clue/components/companyReport'
import subscribeInfoPush from '@/components/subscribeInfoPush'
import { X_BLOCK } from '@/utils/iframeUtils'
import batchUnlockTip from '@/components/batchUnlockTip'


export default {
  name: 'box',
  components: {
    NavTop,
    erpnavtop,
    ThreeLevelView,
    Sidebar,
    menubar,
    callFixed,
    companyReport,
    subscribeInfoPush,
    batchUnlockTip
  },
  data() {
    return {
      hide: false,
      NODE_ENV: '',
      subscribeMsg:false
    }
  },
  beforeDestroy() {
    this.$bus.$off('callFixed')
  },
  mounted() {
    this.$bus.$on('callFixed', (val) => {
      this.$refs.callFixed && this.$refs.callFixed.init(val)
    })
    if (this.$route.query.hide) {
      this.hide = true
    }


    this.NODE_ENV = process.env.NODE_ENV

    if(window[X_BLOCK]){
        // this.subscribeMsg = true
    }
    this.$refs.batchUnlockTip.getUnlockBatchTip()

  },
  computed: {
    hasToken() {
      return getCookie('ERP-Token')
    }
  },
  methods: {
    clickSuggestion() {
      const data = process.env.VUE_APP_7_OPEN + 'suggestion/suggestion'
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = data
      document.body.appendChild(link)
      link.click()
    },
  }

}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.con {
  height: calc(100% - 48px);
}
.con.hide {
  height: 100%;
}

.hide {
  margin-left: 0px !important;
}

.app-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
  // width: calc(100% - 48px);
  min-width: 1280px;
  padding-left: 48px;
  overflow: hidden;
  &.w100{
    
    padding-left: 0px;
  }
}


.main-container {
  height: 100%;
  -webkit-transition: margin-left 0.28s;
  transition: margin-left 0.28s;
  // margin-left: 64px;
  background-color: #F5F6F8;
}
.service {
  position: fixed;
  right: 0;
  bottom: 20%;
  width: 25px;
  // height: 110px;
  background-color: #5b96ec;
  text-align: center;
  padding: 10px 6px;
  border-radius: 3px;
  z-index: 1111;
  box-sizing: border-box;
  img{
    width: 16px;
    height: 16px;
  }

  > p {
    cursor: pointer;

    > span {
      color: #fff;
      // font-size: 14px;
      font-size: 12px;
      display: block;
      margin-top: 5px;
    }
  }
}

.service-list {
  padding: 20px;

  li {
    display: flex;
    align-items: center;
    cursor: pointer;
    &:nth-of-type(1) {
      margin-bottom: 20px;
    }

    span {
      width: 30px;
      height: 30px;
      // background: url(~@/assets/home/13.png) no-repeat;
      margin-right: 10px;
    }
      .consul{
          background: url("~@/assets/gbIcon/kf.png") no-repeat;
          background-size: 100%;
      }
      .suggest{
          background: url("~@/assets/gbIcon/jy.png") no-repeat;
          background-size: 100%;
      }

    h5 {
      font-size: 14px;
      margin-bottom: 5px;
    }

    p {
      color: #999;
    }
  }
}
</style>
